import { Component, AfterViewInit, ElementRef, ChangeDetectionStrategy, inject, CUSTOM_ELEMENTS_SCHEMA, viewChild, OnInit, input } from '@angular/core';
import { ModalController, IonContent, IonGrid, IonRow, IonCol, IonButton, IonIcon } from '@ionic/angular';

import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';

import { MyImageSwiperPreviewModal } from '@components/my-image-swiper-preview/my-image-swiper-preview.component';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";
import { NgClass } from '@angular/common';

register();

@Component({
    selector: 'my-image-swiper-view-modal',
    templateUrl: './my-image-swiper-view.component.html',
    styleUrls: ['./my-image-swiper-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonContent,
        IonGrid,
        IonRow,
        IonCol,
        IonButton,
        IonIcon,
        NgClass,
    ],
    // Web components de Swiper (swiper-container / swiper-slide)
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyImageSwiperViewModal implements OnInit, AfterViewInit {
    private modalCtrl = inject(ModalController);

    readonly swiperEl = viewChild<ElementRef>('swiperEl');

    config: SwiperOptions = {
        centeredSlides: true,
        slidesPerView: 1,
        navigation: true,
        pagination: { clickable: true, dynamicBullets: true },
        initialSlide: 0,
    };

    images = [
        'https://images.pexels.com/photos/2387869/pexels-photo-2387869.jpeg',
        'https://images.pexels.com/photos/2395264/pexels-photo-2395264.jpeg',
        'https://images.pexels.com/photos/2474014/pexels-photo-2474014.jpeg',
        'https://images.pexels.com/photos/2440296/pexels-photo-2440296.jpeg',
    ];

    readonly imagesURLs = input<string[]>(undefined);
    readonly initialSlide = input(0);
    readonly chartSlider = input(false);

    constructor() {
        addIcons({ close });
    }

    // Los inputs (componentProps) se asignan despues del constructor
    ngOnInit() {
        this.config.loop = this.imagesURLs().length === 1 ? false : true;
        this.config.initialSlide = this.initialSlide() > 0 ? this.initialSlide() : 0;
    }

    ngAfterViewInit() {
        const swiperEl = this.swiperEl();
        Object.assign(swiperEl.nativeElement, this.config);
        swiperEl.nativeElement.initialize();
    }

    async openPreviewImage(url) {
        const modal = await this.modalCtrl.create({
            component: MyImageSwiperPreviewModal,
            componentProps: {
                urlImage: url,
            },
            cssClass: 'fullscreen transparent-modal',
        });

        modal.present();
    }

    close() {
        this.modalCtrl.dismiss();
    }
}
